import { useMediaQuery } from './useMediaQuery';

export function useIsSmallScreen(): boolean {
  return useMediaQuery('(max-width: 768px)');
}
